import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import MaintainerReconciliationListScreen from './screens/MaintainerReconciliationListScreen';
import MaintainerReconciliationDetailScreen from './screens/MaintainerReconciliationDetailScreen';

MaintainerReconciliationReport.propTypes = {};

function MaintainerReconciliationReport(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-0">
                <Routes>
                    <Route
                        path=""
                        element={
                            <MaintainerReconciliationListScreen />
                        }
                    />
                    <Route
                        path="/:reconciliationId"
                        element={
                            <MaintainerReconciliationDetailScreen />
                        }
                    />
                    <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default MaintainerReconciliationReport;
